import React, { useState } from "react";
import Input from "../Input";
import EyeOff from "../../icons/EyeOff";
import EyeOn from "../../icons/EyeOn";

const PasswordInput = (props) => {
  const [secure, setSecure] = useState(true);

  return (
    <Input
      {...props}
      type={secure ? "password" : "text"}
    >
      <button
        type="button"
        onClick={() => setSecure(!secure)}
      >
        {secure ? <EyeOff /> : <EyeOn />}
      </button>
    </Input>
  );
};

export default PasswordInput;
